import React, { useState, useEffect } from "react";

import { BO_USER_PROFILE, BO_USER_PROFILE_RESULT } from "configs/constants";

import Form from "components/Form";
import Table from "@Components/Table";
import * as Yup from "yup";
import { Paper } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import { useTranslation } from "react-i18next";

import eightAxios from "configs/axiosConfig";
import LoadingIcon from "@Components/LoadingIcon/LoadingIcon";
import axios from "axios";

let model = [
  { id: "SN", label: "SN", type: "string" },
  { id: "employee_id", label: "Employee ID", type: "string" },
  { id: "mobile_number", label: "Mobile Number", type: "string" },
  { id: "office_number", label: "Office Number", type: "string" },
  { id: "estate_code", label: "Estate Code", type: "string" },
  { id: "estate_name", label: "Estate Name", type: "string" },
  { id: "division_code", label: "Division Code", type: "string" },
  { id: "division_name", label: "Division Name", type: "string" },
  { id: "block_code", label: "Block Code", type: "string" },
  { id: "block_name", label: "Block Name", type: "string" },
  { id: "employee_status", label: "Employee Status", type: "string" },
  { id: "status", label: "Status", type: "string" },
  { id: "remarks", label: "Remarks", type: "string" },
];

const initialValues = {};

const SUPPORTING_DOCUMENT_FORMATS = [
  ".csv",
  "text/csv",
  "application/vnd.ms-excel",
];

const detailURL = "/configuration/get-config/";
const templateURL = "download-template/?type=bo_user";
const FileDownload = require("js-file-download");

const BackOfficeUserProfileUpload = () => {
  const [displayTable, setDisplayTable] = useState(false);
  const [buttonCounter, setButtonCounter] = useState(0);
  const [tableData, setTableData] = useState(null);
  const [fileSize, setFileSize] = useState(null);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const validationSchema = Yup.object({
    file: Yup.mixed()
      .required("File is required")
      .test("fileSize", "File is too large", (value) => {
        if (value === null) {
          return false;
        } else if (typeof value === "string") {
          return true;
        } else {
          return value.size <= fileSize;
        }
      })
      .test("fileType", "Unsupported file type", (value) => {
        if (value === null) {
          return false;
        } else if (typeof value === "string") {
          return true;
        } else {
          return SUPPORTING_DOCUMENT_FORMATS.includes(value.type);
        }
      }),
  });

  const fetchDetails = () => {

    setLoading(true);
    eightAxios
      .get(detailURL)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.max_file_upload_size) {
            setFileSize(response.data.max_file_upload_size * 1024 * 1024);
          }
        }
        setLoading(false);
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response);
        }
        setLoading(false);
      });
  };

  const fetchTemplate = () => {
    setLoading(true);
    const API_VERSION = "v1";
    const API_URL = process.env.REACT_APP_API_URL;
    let baseURL = `${API_URL}${API_VERSION}/`;
    const headers = {
      Authorization: `JWT ${localStorage.getItem("token")}`,
    };
    axios({
      url: baseURL + templateURL,
      method: "get",
      headers: headers,
      responseType: "blob",
    })
      .then(function (response) {
        FileDownload(response.data, "BO_User_upload_template.csv");
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchDetails();
  }, []);

  const formFields = [
    {
      type: "fileupload",
      name: "file",
      accept: ".csv",
      label: "Back Office User Profile File",
      supportedTypes: [t("csv file only")],
      buttonText: "Browse",
    },
  ];

  const formButtons = [
    {
      type: "submit",
      label: "Submit",
      color: "primary",
    },
  ];

  if (loading) {
    return <LoadingIcon image text="Loading" />;
  }

  return (
    <div>
      <Paper style={{ padding: "10px" }}>
        <Form
          initialValues={initialValues}
          submitUrl={BO_USER_PROFILE}
          formFields={formFields}
          formButtons={formButtons}
          afterSubmit={(success) => {
            if (success) {
              setDisplayTable(true);
              setButtonCounter(buttonCounter + 1);
            }
          }}
          isMultipart
          formTitle="Back Office User Profile Upload"
          validationSchema={validationSchema}
          noTypography={true}
          downloadTemplate={fetchTemplate}
          noFeature={true}
        />
        {tableData && tableData.extra ? (
          <Alert
            severity={tableData.extra.failed > 0 ? "error" : "success"}
            style={{ marginTop: "10px" }}
          >
            {`Total: ${
              tableData.extra.success + tableData.extra.failed
            }, Successful: ${tableData.extra.success}, Failed: ${
              tableData.extra.failed
            }`}
          </Alert>
        ) : null}
      </Paper>

      {displayTable ? (
        <Table
          model={model}
          noFilter
          proxyURL={BO_USER_PROFILE_RESULT}
          outerFetchTrigger={buttonCounter}
          noAddButton
          excelExport={{ fileName: "BackOfficeResult" }}
          polling
          setTableData={setTableData}
        />
      ) : null}
    </div>
  );
};

export default BackOfficeUserProfileUpload;
